import { useMemo } from 'react';
import customerActionMatrix, { evaluateConditions } from '../components/actions/configs/customerActionMatrix';
import merchantActionMatrix, { evaluateMerchantConditions } from '../components/actions/configs/merchantActionMatrix';

const useActionMatrix = (entity, entityType, userRole) => {
  return useMemo(() => {
    console.log('useActionMatrix called with:', { entity, entityType, userRole });
    
    if (!entity || !entityType || !userRole) {
      console.log('useActionMatrix early return due to missing params');
      return [];
    }

    // Eliminate order item actions globally (moved to fulfillment group level)
    if (entityType === 'orderItem') {
      return [];
    }

    // Select appropriate action matrix based on user role
    const actionMatrix = userRole === 'customer'
      ? customerActionMatrix
      : merchantActionMatrix;

    console.log('Selected action matrix for role:', userRole, actionMatrix);

    // Get actions for the entity type
    const entityActions = actionMatrix[entityType] || [];
    
    console.log('Entity actions for type', entityType, ':', entityActions);
    console.log('Entity actions IDs:', entityActions.map(a => a.id));

    // Filter actions based on conditions
    const availableActions = entityActions.filter(action => {
      // console.log('Checking action:', action.id, 'conditions:', action.conditions);
      
      // Create context object
      const context = { entityType };
      
      // Use the appropriate evaluation function
      const isValid = userRole === 'merchant' 
        ? evaluateMerchantConditions(action.conditions, entity, userRole, context)
        : evaluateConditions(action.conditions, entity, userRole, context);
      
      // console.log('Action', action.id, 'is valid:', isValid);
      return isValid;
    });

    console.log('Final available actions:', availableActions.map(a => a.id));
    return availableActions;
  }, [entity, entityType, userRole]);
};

export default useActionMatrix; 